interface ErrorTextProps {
  message: string;
}

export const INTERNAL_SERVER_ERROR_TEXT = 'our servers are kinda broken at the moment 😅, try again later...';

const ErrorText: React.FC<ErrorTextProps> = ({ message }) => {
  return (
    <p className='mt-2 text-red-500'>{message}</p>
  );
}

export default ErrorText;
